
import { defineComponent, PropType } from 'vue'
import JrSelect from '@/components/jr-parts/JrSelect.vue'

export interface StatusList {
  code: string
  status: string
}

export default defineComponent({
  name: 'StatusSelect',
  components: {
    JrSelect,
  },
  emits: ['update:modelValue', 'update:status'],
  props: {
    modelValue: {
      type: [String],
      required: true,
    },
    statuses: {
      type: Object as PropType<string>,
      required: true,
      default: null,
    },
    blank: {
      type: Boolean,
      required: false,
      default: true,
    },
    popperAppendToBody: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props, context) {
    let statusList: Array<StatusList> = []
    if (props.blank) {
      // 空白の選択肢を付与する
      statusList.push({
        code: '',
        status: ' ',
      })
    }

    let statusArray: Array<StatusList> = Object.entries(props.statuses).map(([key, value]) => ({
      code: key,
      status: value,
    }))
    statusList.push(...statusArray)

    return {
      statusList,
      update: (value: string) => {
        // 選択したvalueを返す
        context.emit('update:modelValue', value)
      },
      updateName: (status: string | null) => {
        // 選択したstatusを返す
        context.emit('update:status', status)
      },
    }
  },
})
